import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { FullPageMessage } from "./FullPageMessage";
import { useAuth } from "./useAuth";

/** /login and /signup: hand over to the MDF-branded login page. */
export default function LoginRedirect({ signup = false }: { signup?: boolean }) {
  const { login, signup: startSignup } = useAuth();
  const location = useLocation();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const returnTo = (location.state as { from?: string } | null)?.from;
    void (signup ? startSignup({ returnTo }) : login({ returnTo }));
  }, [signup, login, startSignup, location.state]);

  return <FullPageMessage spinner title="Opening the sign-in page…" />;
}
